// extracted by mini-css-extract-plugin
module.exports = {"container":"suggestions_container__Lkj-Y","settingsContainer":"suggestions_settingsContainer__3ljZA"};